import {ThreeBigEquipment} from '../ThreeBigEquipment';

export class ThreeRefrigeratorEquipment extends ThreeBigEquipment {

}